import { Constructor } from '../types/constructor.type';
import { BaseMatcher, Matcher } from './base.matcher';

export function isInstanceOf<T>(
  clazz: Constructor<T>,
  message: () => string = () => 'value is not instance of ',
): Matcher<T> {
  return new BaseMatcher<T>((input) => {
    return input instanceof clazz;
  }, message);
}
